<script setup>
import '@campact/camper/core/CmprButton';
import { ref } from 'vue';
import CmprModal from '@cta/frontend/components/CmprModal.vue';

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const hidden = ref(false);
</script>

<template>
  <CmprModal
    class="foundation-hint-modal"
    :visible="visible && !hidden"
    @update:visible="hidden = true"
  >
    <template #content>
      <h2 class="mb-40">
        Demokratie-Stiftung Campact
      </h2>
      <p>
        Danke, dass Du Campact großzügig unterstützen möchtest. Campact e.V. kann für Deine Spende keine Spendenquittung
        ausstellen. Die gemeinnützige Demokratie-Stiftung Campact könnte für Dich passender sein: Du erhältst eine
        Zuwendungsbestätigung und kannst die Spende steuerlich geltend machen.
      </p>
    </template>

    <template #footer>
      <cmpr-button
        data-analytics-id="donate-call-form-amount-overlay-accept-button"
        href="https://demokratie-stiftung-campact.de/unterstuetzen/spenden-fuer-die-stiftung/"
        rel="noopener noreferrer"
        size="small"
        target="_blank"
        type="link"
        variant="secondary"
      >
        Klicke hier, um für die Stiftung zu spenden
      </cmpr-button>

      <cmpr-button
        data-analytics-id="donate-call-form-amount-overlay-decline-button"
        size="small"
        variant="tertiary"
        @click.prevent="hidden = true"
      >
        Zurück zum Spendenformular
      </cmpr-button>
    </template>
  </CmprModal>
</template>
